import { LE } from "@/constants/enums";
import { type Incident, type IncidentFormKit, type IncidentNew } from "@/views/incident/incident";
import { murnAddressFromFormkit, plainMurnAddressFromFormkit, plainMurnAddressToFormkit } from "@modernary/mui/components/fk";
import { fillAddressLookupValues, fillLookupValuesByPropertyNames, fillPrefixedAddressLookupValues } from "@modernary/mui/components/lookup";
import { taxMapKeyAdapter } from "@modernary/mui/components/taxMapKey";
import type { Organization } from "../organization/organization";

export default {
  addAuthRequestFields,
  getInitialData,
  fromFormkit,
  toFormkit,
  skinnyResponseAdapter,
  responseAdapter,
};

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Incident }) {
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Incident }) {
  await skinnyResponseAdapter(response);
  await fillAddressLookupValues(response.data);
  return response.data;
}

function addAuthRequestFields(entity: Incident | IncidentNew) {
  return entity;
}

function getInitialData() {
  const result = {} as Incident; //TODO:TS
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Incident) {
  plainMurnAddressToFormkit(data);
  taxMapKeyAdapter(data as Incident);
  //TODO: Mask Bug phone number only set to be undefined to fix formkit bug. Once formkit resolves bug remove
  if (!data.callerPhone) {
    data.callerPhone = undefined;
  }
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: IncidentFormKit) {
  if (data.ownerCreate)
    murnAddressFromFormkit(data.ownerCreate, 'mail');
  if (data.operatorCreate)
    murnAddressFromFormkit(data.operatorCreate, 'mail');
  plainMurnAddressFromFormkit(data as Incident);
  //TODO: Mask Bug remove this once the if above is removed.
  if (data.callerPhone === undefined) {
    data.callerPhone = null;
  }
}